export default "__VITE_ASSET__3095c29e__"